import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "normal-text" }
const _hoisted_2 = {
  key: 0,
  class: "modal-background"
}
const _hoisted_3 = { class: "modal-content full-width" }
const _hoisted_4 = { class: "modal-content-header" }
const _hoisted_5 = { class: "list-text-bold" }
const _hoisted_6 = ["innerHTML"]

import { ref } from 'vue';
import __ from '@/translate';


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

const openedTerms = ref<keyof typeof legalText | null>(null);

const legalText = {
  privacy: {
    title: 'privacy_policy_title',
    content: 'privacy_policy_content',
  },
  'T&C': {
    title: 'terms_and_conditions_title',
    content: 'terms_and_conditions_content',
  },
};

function closeTerms() {
  openedTerms.value = null;
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", null, [
      _createElementVNode("div", {
        class: "normal-text-bold",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openedTerms.value = 'privacy'))
      }, _toDisplayString(_unref(__)('privacy_policy')), 1),
      _createElementVNode("div", {
        class: "normal-text-bold",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openedTerms.value = 'T&C'))
      }, _toDisplayString(_unref(__)('terms_and_conditions')), 1),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(__)('copyright')) + ": Nordic Dental, " + _toDisplayString(new Date().getFullYear()) + ".", 1)
    ]),
    (openedTerms.value && legalText[openedTerms.value])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(__)(legalText[openedTerms.value].title)), 1),
              _createElementVNode("div", {
                class: "modal-close",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (closeTerms()))
              }, _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "x-icon" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", {
              class: "modal-content-legal",
              innerHTML: _unref(__)(legalText[openedTerms.value].content)
            }, null, 8, _hoisted_6)
          ])), [
            [_directive_click_outside, closeTerms]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})